import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Users, FileText, Shield } from "lucide-react";
import { toast } from "sonner";

export const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    toast.success("Successfully logged out");
    navigate("/login/admin");
  };

  const menuItems = [
    {
      name: "Dashboard",
      icon: LayoutDashboard,
      path: "/admin/dashboard",
    },
    {
      name: "Manage Employees",
      icon: Users,
      path: "/admin/employees",
    },
    {
      name: "Attendance Reports",
      icon: FileText,
      path: "/admin/reports",
    },
  ];

  return (
    <div className="flex h-screen overflow-hidden bg-slate-900 dark" data-testid="admin-layout">
      {/* Sidebar */}
      <div className="w-64 flex-shrink-0 border-r border-slate-700 bg-slate-800 hidden md:flex flex-col">
        <div className="p-6 border-b border-slate-700">
          <div className="flex items-center gap-3">
            <div className="bg-blue-600 rounded-lg p-2">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <div>
              <a href="https://nix-southeast-asia.com" target="_blank" rel="noopener noreferrer" className="block">
                <h2 className="font-bold text-white text-lg hover:text-blue-400 transition-colors">NIX Admin</h2>
                <p className="text-xs text-slate-400">Control Panel</p>
              </a>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path}>
                <Button
                  variant="ghost"
                  className={`w-full justify-start text-slate-300 hover:text-white hover:bg-slate-700 transition-colors ${
                    isActive ? "bg-slate-700 text-white" : ""
                  }`}
                  data-testid={`menu-${item.path.split('/').pop()}`}
                >
                  <Icon className="w-5 h-5 mr-3" />
                  {item.name}
                </Button>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-slate-700">
          <Button
            onClick={handleLogout}
            variant="ghost"
            className="w-full justify-start text-red-400 hover:text-red-300 hover:bg-red-950/50"
            data-testid="admin-logout-button"
          >
            <LogOut className="w-5 h-5 mr-3" />
            Logout
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="p-8">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;